// Dialog destrutivo de cancelamento — usa Radix Dialog (já dep do projeto).
// DESIGN_SYSTEM §componentes/Modal:
//  - padding 28-32, border-line, radius r4, shadow-lg
//  - title sans 20px/600
//  - actions à direita; primário (destrutivo) por último
//  - foco trapped (Radix faz), Esc fecha (Radix faz)

import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

import { cn } from '@control-center/ui';

import { PillButton } from './PillButton';

interface CancelClientDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clientName: string;
  isPending?: boolean;
  onConfirm: () => void;
}

export function CancelClientDialog({
  open,
  onOpenChange,
  clientName,
  isPending,
  onConfirm,
}: CancelClientDialogProps): JSX.Element {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={cn(
            'fixed inset-0 z-40 bg-black/60 backdrop-blur-[2px]',
            'data-[state=open]:animate-in data-[state=closed]:animate-out',
            'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
          )}
        />
        <Dialog.Content
          aria-describedby="cancel-client-desc"
          className={cn(
            'fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2',
            'w-[min(440px,calc(100vw-32px))] rounded-[14px] border border-line bg-panel shadow-lg',
            'p-7',
            'focus:outline-none',
          )}
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <Dialog.Title className="text-[20px] font-semibold tracking-[-0.01em] text-ink">
                Cancelar cliente
              </Dialog.Title>
              <p id="cancel-client-desc" className="mt-2 text-[13px] leading-[1.55] text-muted">
                Cancelar <span className="font-medium text-ink-2">{clientName}</span>. Status muda
                pra <span className="font-mono text-[12px] text-muted-2">cancelado</span> e o
                histórico fica preservado. Essa ação pode ser revertida em até 30 dias.
              </p>
            </div>
            <Dialog.Close asChild>
              <button
                type="button"
                aria-label="Fechar"
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[6px] text-muted transition-colors hover:bg-panel-2 hover:text-ink"
              >
                <X size={15} strokeWidth={2} />
              </button>
            </Dialog.Close>
          </div>

          <div className="mt-6 flex items-center justify-end gap-2">
            <Dialog.Close asChild>
              <PillButton disabled={isPending}>Manter</PillButton>
            </Dialog.Close>
            <PillButton danger onClick={onConfirm} disabled={isPending}>
              {isPending ? 'Cancelando…' : 'Cancelar cliente'}
            </PillButton>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
